import Compressor from 'compressorjs'

const compressor = {}

compressor.image = function(file) {
  return new Promise((resolve, reject) => {
    new Compressor(file, {
      quality: 0.6,
      maxHeight: 1280,
      success(result) {
        console.log(result)
        console.log(result.name)
        resolve(result)
      },
      error(error) {
        console.log(error.message)
        reject(error.message)
      }
    })
  })
}

export default compressor
